import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import envConfig from "../../lib/config"
import moment from 'moment';
import { deletfaq, getfaqlist } from '../../actions/users';
import ReactHtmlParser from 'react-html-parser'
import { useNavigate } from 'react-router-dom';

const FAQList = () => {
    const navigate = useNavigate()
    const [userdet, setUser] = useState();

    useEffect(() => {
        getFaqList();
    }, []);

    const getFaqList = async () => {
        var test = await getfaqlist();
        if (test.Success)
            setUser(test.userValue);
        else
            toastAlert('error', "Error on Server");
    }

    const add =async () => {
        window.location="/faqadd";
    }

    function editR(id) {
        if (id != '') {
              navigate({
                pathname:"/faqedit/"+id._id,
                state:{
                  items:id
                }
              })
        }

    }

    function deleteR(id) {
        if (id != '') {
            deletfaq(id);
            toastAlert("success", 'Faq deleted successfully');
            getFaqList();
        }
    }

    const columns = [
        {
            key: "ind",
            text: "S.NO",
            className: "name",
            align: "center",
            sortable: false,
            cell: (row, index, column, id) => <p className='text-center exchange_table_values'>{index + 1}</p>,
        },
        {

            key: "answer",
            text: "Answer",
            className: "answer",
            align: "center",
            sortable: false,
            cell: record =>
                <div className='text-center exchange_table_values'>{ReactHtmlParser(record.answer)}</div>
        },
        {
            key: "question",
            text: "Question",
            className: "question",
            align: "center",
            sortable: false,
            cell: (item) => <p className='text-center exchange_table_values'>{item.question}</p>,
        },
        {
            key: "date",
            text: "Date",
            className: "Date",
            align: "center",
            sortable: false,
            cell: record =>
                <div className='text-center exchange_table_values'><p>{moment(record.date).format('MMMM,Do YYYY, hh:mm A')}</p></div>
        },

        {
            key: "action",
            text: "Action",
            className: "action",
            width: 100,
            align: "center",
            sortable: false,
            cell: record => {
                const checkin = record.status;
                if (checkin == '0') {
                    var lockVal = 'fa fa-lock';
                } else {
                    var lockVal = 'fa fa-unlock';
                }

                return (
                    <div className='text-center exchange_table_values'>
                        <button
                            data-toggle="modal"
                            data-target="#update-template-modal"
                            className="btn btn-primary btn-sm"
                            onClick={() => editR(record)}

                            style={{ marginRight: '5px' }}>
                            <i className="fa fa-edit"></i>
                        </button>
                        <button
                            className="btn btn-danger btn-sm mr-1"
                            onClick={() => deleteR(record._id)}>
                            <i className="fa fa-trash"></i>
                        </button>
                      
                    </div>
                );
            }
        },
    ];
    const config = {
        page_size: 5,
        length_menu: [10, 20, 50],
        filename: "Users",
        no_data_text: "No user found!",
    
        language: {
          length_menu: "Show _MENU_ result per page",
          filter: "Filter in records...",
          info: "Showing _START_ to _END_ of _TOTAL_ records",
          pagination: {
            first: "First",
            previous: <> Previous </>,
            next: <>Next</>,
            last: "Last",
          },
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: true,
        show_info: true,
        defaultSortAsc: true,
    };
    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'FAQ List'} />

                        <div className="common_page_scroller mt-5 pe-2">
                            <div className="page_header">
                                <h2>FAQ List</h2>
                                <div>
                                    <div className="selection_sec">
                                        <button type='button' onClick={add}>ADD</button>
                                    </div>

                                </div>
                            </div>
                            <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                                <ReactDatatable
                                    config={config}
                                    records={userdet}
                                    columns={columns}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default FAQList